import { useState, useEffect, useRef } from 'react';

export const useCalendarData = (fetchAdmin, url, revision = 0) => {
  const [state, setState] = useState({ url: null, data: null, loading: true, refreshing: false, error: '' });
  const cache = useRef(new Map());
  const seq = useRef(0);
  useEffect(() => {
    const controller = new AbortController();
    const request = ++seq.current;
    const cached = cache.current.get(url);
    setState({ url, data: cached || null, loading: !cached, refreshing: !!cached, error: '' });
    (async () => {
      try {
        const response = await fetchAdmin(url, { signal: controller.signal });
        if (!(response.headers.get('content-type') || '').includes('json')) throw new Error(`Calendar unavailable (HTTP ${response.status})`);
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not load calendar data');
        if (controller.signal.aborted || seq.current !== request) return;
        cache.current.set(url, data);
        if (cache.current.size > 16) cache.current.delete(cache.current.keys().next().value);
        setState({ url, data, loading: false, refreshing: false, error: '' });
      } catch (error) {
        if (!controller.signal.aborted && seq.current === request) {
          setState({ url, data: cached || null, loading: false, refreshing: false, error: error.name === 'SyntaxError' ? 'Calendar returned an invalid response' : error.message });
        }
      }
    })();
    return () => controller.abort();
  }, [fetchAdmin, url, revision]);
  // A changed filter must never render the previous profile's rows, even for
  // the frame before the effect starts its replacement request.
  return state.url === url ? state : { url, data: cache.current.get(url) || null,
    loading: !cache.current.has(url), refreshing: cache.current.has(url), error: '' };
};